import { CONCILIATION_ES_MX } from "#pages/backoffice/conciliation/translations/conciliation-es-mx";
import eventConference from "./event-conference.json";
import customerAndSupplier from "./customer-and-supplier.json";
import accountsPayableReceivable from "./accounts-payable-receivable.json";
import bills from "./bills.json";
import finExManagerialReport from "./finex-managerial-report.json";
import planOfAccounts from "./plan-of-accounts.json";
import stockTransferHistory from "./stock-transfer-history.json";

export const backofficeEsMX = {
	conciliation: CONCILIATION_ES_MX,
	customerAndSupplier,
	eventConference,
	accountsPayableReceivable,
	bills,
	finExManagerialReport,
	planOfAccounts,
	stockTransferHistory,
	cashFlow: {
		pageTitle: "Flujo de caja",
		pageParagraph:
			"Toda empresa necesita un flujo de caja para acompañar sus entradas y salidas. El gestor que conoce su flujo financiero es consciente de lo que entra y sale al día, a la semana y al mes. Contar con una herramienta como esta y utilizarla es de suma importancia para la toma de decisiones y para saber hacia dónde se dirige el negocio. Actualmente, nuestro flujo de caja considera la fecha de vencimiento de los títulos registrados en cuentas por pagar y por cobrar.",
		tooltipMessage:
			"Las líneas de categorías de nivel {{level}} muestran la suma de todos los niveles agrupados dentro de ella.",
		fileName: "flujo-de-caja",
		topActions: {
			lblAccountName: "Buscar por Cuenta",
			plhAccountName: "Ingrese el nombre de la cuenta",
			lblDate: "Filtrar por Vencimiento",
			btnPdf: "Exportar a PDF",
			btnExcel: "Exportar a Excel",
		},
		totalizers: {
			income: "Total de Ingresos",
			costs: "Total de Costos",
			expenses: "Total de Gastos",
			balance: "Total de Ingresos, Costos y Gastos",
		},
		rowTotal: "Saldo del Período",
		rowHead: "Saldo inicial",
		rowTail: "Saldo del día",
		viewPerDay: "Ver por día",
		viewPerMonth: "Ver por mes",
		columns: {
			income: "Ingresos",
			costs: "Costos",
			expenses: "Gastos",
			level: "Nivel",
			name: "Nombre",
			day: "Día",
			month: "Mes",
		},
		bills: {
			searchAccountPlaceholder: "Ingrese el nombre de la cuenta",
			dueDateFilter: "Filtrar por vencimiento",
			exportExcel: "Exportar a excel",
			emptyText: "No se encontraron títulos para el período seleccionado.",
			cards: {
				receipts: "Ingresos",
				expenses: "Gastos",
				finalBalance: "Saldo final del período",
			},
			columns: {
				dueDate: "Vencimiento",
				description: "Descripción",
				counterparty: "Cliente/Proveedor",
				account: "Cuenta corriente",
				category: "Categoría",
				status: "Situación",
				value: "Valor",
			},
			status: {
				received: "Recibido",
				paid: "Pagado",
				pending: "Abierto",
				overdue: "Vencido",
			},
			openingBalance: "Saldo inicial",
			dayBalance: "Saldo del día {{date}}",
			periodBalance: "Saldo del período",
		},
	},
	costCenter: {
		costCenter: "Centros de costo",
		addCostCenter: "Agregar centro de costo",
		editCostCenter: "Editar centro de costo",
		namePlaceholder: "Nombre del centro de costo",
		name: "Nombre",
		action: "Acciones",
	},
	bankAccounts: {
		titlePage: "Cuentas bancarias",
		addAccount: "Registrar cuenta",
		columnsTable: {
			name: "Nombre",
			bank: "Banco",
			agency: "Sucursal",
			purpose: "Propósito de la cuenta",
			actions: "Acciones",
			account: "Cuenta",
			cpfOrCnpj: "RFC",
			ownerName: "Titular",
			currentBalance: "Saldo actual",
			initialBalance: "Saldo inicial",
		},
		form: {
			newNameBankAccount: "Nombre de la cuenta",
			bank: "Institución bancaria",
			agency: "Código de sucursal",
			purpose: "Propósito de la cuenta",
			account: "Cuenta corriente con dígito",
			cpfOrCnpj: "RFC",
			ownerName: "Titular",
			addAccount: "Agregar cuenta bancaria",
			namePlaceholder: "Ingrese un nombre para la cuenta",
			bankPlaceholder: "Buscar por institución",
			purposePlaceholder: "Buscar por tipo de cuenta",
			selectPurpose: "Seleccione el propósito de la cuenta",
			followInstructions: "Siga las instrucciones para continuar",
			accessBankAccount:
				"Para continuar, acceda a su banca en línea y verifique si puede descargar su estado de cuenta en formato OFX.",
			verifyBankAccount:
				"Si el banco no exporta este formato de archivo, haga clic en Finalizar para avanzar sin validación.",
			successContent:
				"La información importada del OFX coincide con la información ingresada en el paso anterior",
			inconsistentContent:
				"Alguna información importada del OFX no coincide con la información ingresada en el paso anterior. Al continuar, reemplazaremos la información ingresada con la importada.",
			emptyBankData:
				"Alguna información necesaria para la validación de la cuenta no está presente en el archivo OFX seleccionado. Haga clic en continuar para finalizar el registro sin validación.",
			imported: "Importadas",
			registered: "Registradas",
			titlesContentVerifield: {
				success: "Información verificada",
				inconsistency: "Información conflictiva",
				emptyBankData: "Información faltante",
			},
			ofxTitles: {
				upload: "Haga clic o arrastre el archivo OFX",
				file: "Archivo OFX",
			},
			incompatibleFile: "Archivo incompatible",
			purposeList: {
				inHouseFlow: "Caja (fondo de cambio)",
				creditCard: "Tarjeta de crédito",
				virtualWallet: "Cartera virtual",
				applicationAccount: "Cuenta de inversión",
				checkingAccount: "Cuenta Corriente",
				savingsAccount: "Cuenta de Ahorro",
			},
			accountPlaceholder: "Ingrese la cuenta",
			agencyPlaceholder: "Ingrese el código",
			cpfPlaceholder: "RFC",
			ownerNamePlaceholder: "Nombre del titular de la cuenta",
			unlink: "Desvincular cuenta bancaria",
			linkBankAccount: "Vincular cuenta bancaria",
			defaultAccount: "Establecer como cuenta principal:",
			defaultAccountTooltip:
				"La cuenta principal se utiliza para completar automáticamente los formularios que requieren esta información.",
			default: "Predeterminado",
			initialBalance: "Saldo inicial en $",
			initialBalanceDate: "Fecha del saldo inicial",
			balancePlaceholder: "0.00",
			balanceDatePlaceholder: "dd/mm/aaaa",
			saveChanges: "Guardar cambios",
			errors: {
				required: "Campo obligatorio",
				name: "Ingrese un nombre válido",
				account: "Ingrese un número de cuenta válido",
				agency: "Ingrese un número de sucursal válido",
				cpf: "RFC inválido",
				cnpj: "RFC inválido",
				formatInvalid: "Este tipo de formato no es compatible",
			},
		},
		confirmModal: {
			editInfo: "Editar información",
			cancelMessage:
				"No ha guardado los cambios realizados. ¿Desea continuar de todos modos?",
			cancelButton: "Salir sin guardar",
			confirmButton: "Guardar cambios",
			deleteAccount: "Eliminar cuenta",
			deleteMessage:
				"La eliminación de la cuenta es una acción definitiva. ¿Desea continuar con la eliminación?",
			deleteTransferError:
				"No se puede eliminar esta cuenta porque está vinculada a pagos o cobros registrados.",
			deleteMainError:
				"No se puede eliminar esta cuenta porque está registrada como cuenta principal.",
			updateMainAccount: "Cambiar cuenta principal",
			updateMainAccountMessage:
				"Ya existe una cuenta registrada como principal en esta ubicación, si continúa, esta cuenta será reemplazada. ¿Desea continuar de todos modos?",
			confirmUpdate: "Cambiar cuenta",
			deactivateTitle: "Desactivar cuenta",
			deactivateMessage:
				"¿Está seguro de que desea desactivar la cuenta {{name}}? La cuenta no será eliminada. El historial de movimientos se conserva y puede reactivarla en cualquier momento.",
			deactivateConfirm: "Desactivar cuenta",
		},
		subtitlePage:
			"Registre, gestione y haga seguimiento de las transacciones de sus principales cuentas bancarias",
		tabs: {
			active: "Cuentas activas",
			inactive: "Cuentas desactivadas",
		},
		emptyTab: "No hay cuentas en esta pestaña",
		comingSoon: "Próximamente",
		zigCard: {
			title: "Cuenta ZIG",
			viewExtract: "Ver extracto",
			platform: "Disponible en la plataforma",
			withdraw: "Disponible para retiro",
			anticipation: "Disponible para anticipación",
			future: "Movimientos futuros",
		},
		card: {
			viewTransactions: "Ver transacciones",
			agencyAbbr: "Suc.",
			accountAbbr: "Cta.",
		},
		migration: {
			banner: {
				title: "Actualiza el saldo de tus cuentas bancarias",
				description:
					"Tus cuentas bancarias tienen una nueva apariencia. Para que tus saldos aparezcan correctamente en la nueva experiencia, actualiza tus cuentas con el saldo más reciente.",
			},
			badge: "Actualizar saldo",
			accountWarningTooltip: "Accede a los detalles de la cuenta y actualiza el saldo",
		},
		switch: {
			activate: "Activar cuenta",
			deactivate: "Desactivar cuenta",
		},
		menu: {
			ariaLabel: "Acciones de la cuenta",
			editData: "Editar datos de la cuenta",
			updateBalance: "Actualizar saldo",
		},
		emptyStateTitle: "Ninguna cuenta bancaria registrada",
		emptyStateSubtitle: "Agrega tu primera cuenta bancaria para empezar a usar",
		notification: {
			deleteAccount: "Cuenta eliminada exitosamente",
			createAccount: "Cuenta creada exitosamente",
			updateAccount: "Cuenta editada exitosamente",
			accountActivated: "Cuenta activada exitosamente",
			accountDeactivated: "Cuenta desactivada exitosamente",
		},
	},
	reports: {
		noComponent: "Estará disponible pronto",
		reportNames: {
			expense: {
				perDescripion: "Gasto por Descripción",
				perDay: "Gasto por Día",
				perType: "Gasto por Tipo",
				perCategory: "Gasto por Categoría",
				perCostCenter: "Gasto por Centro de Costo",
				perHistory: "Gasto Histórico",
				perAnything: "Gasto Pagado a.",
			},
			receipts: {
				perDescripion: "Ingreso por Descripción",
				perDay: "Ingreso por Día",
				perType: "Ingreso por Tipo",
				perCategory: "Ingreso por Categoría",
				perCostCenter: "Ingreso por Centro de Costo",
				perHistory: "Ingreso Histórico",
				perAnything: "Ingreso Recibido de...",
			},
			cashFlow: {
				extract: "Extracto",
				expensses: "Gastos/Ingresos",
				history: "Histórico",
				demonstrative: "Demostrativo",
			},
		},
		graphs: {
			totalExpenses: "Total gastos",
			totalReceipts: "Total cobros",
			finalBalance: "Saldo final",
			periodBalance: "Balance del período",
			previousBalance: "Saldo anterior",
			date: "Fecha",
			description: "Descripción",
			category: "Categoría",
			receipts: "Ingresos",
			expenses: "Gastos",
			dateCaps: "FECHA",
			receiptCaps: "COBRO",
			expenseCaps: "GASTO",
			valueCaps: "VALOR",
			totalCaps: "TOTAL",
			type: "Tipo",
			costCenterCaps: "CENTRO DE COSTO",
			tax: "Impuesto",
			receipt: "Ingreso",
			expense: "Gasto",
			result: "Resultado antes de impuestos",
			profit: "Utilidad del ejercicio",
			descriptionCaps: "DESCRIPCIÓN",
			value: "Valor",
			balance: "Balance",
			period: "Período",
			until: "hasta",
			totalReceived: "Total Recibido",
			totalPaid: "Total Pagado",
			finalBalanceExtract: "Balance final",
			periodBalanceExtract: "Balance en el período",
			previousBalanceExtract: "Balance previo",
			supplierCaps: "PROVEEDOR",
			typeCaps: "TIPO",
		},
	},
	billType: {
		categories: "Categorías",
		addCategory: "Agregar categoría de cuenta",
		addType: "Agregar tipo de cuenta",
		createCategory: "Crear categoría de cuenta",
		editCategory: "Editar categoría de cuenta",
		categoryName: "Nombre de la categoría de cuenta",
		createTypeIn: "Crear tipo de cuenta en {{categoryName}}",
		editTypeIn: "Editar tipo de cuenta en {{categoryName}}",
		createType: "Crear tipo de cuenta",
		editType: "Editar tipo de cuenta",
		typeName: "Nombre del tipo de cuenta",
		name: "Nombre",
		actions: "Acciones",
	},
	viewLevel: "Ver nivel {{level}}",
};
